export default "__VITE_ASSET__DMzfkQ2h__"